var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"redirect-if-no-permission",rawName:"v-redirect-if-no-permission:ZONES",arg:"ZONES"}]},[_c('DataTable',{attrs:{"url":"location-cluster","fieldsHiddenMain":[
        'deleted_at','centroid'
    ],"perPage":"100","titles":_vm.titles,"actionsExtraMain":_vm.actionsExtraMain,"formatter":_vm.formatter,"title":_vm.$t('zonesPage.pageTitle')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }